import { connect } from 'react-redux';
import { v4 } from 'uuid';

import { unitsTypes } from '../../../constants/dashboards';
import ButtonExecuteDashboard from '../../../components/dashboards/cards/ButtonExecuteDashboard';
import { executeDashboardEventQueries } from '../../../actions/dashboards/events';
import {
  executeDashboardComposeRevenue,
  executeDashboardRevenue,
} from '../../../actions/dashboards/revenue';
import { executeDashboardUsers } from '../../../actions/dashboards/users';
import { executeDashboardRetentionComplex } from '../../../actions/dashboards/retentionComplex';
import { executeDashboardUnitQueriesStart } from '../../../actions/dashboards/dashboards';
import { executeDashboardRetentionSimple } from '../../../actions/dashboards/retention';
import { executeDashboardFunnel } from '../../../actions/dashboards/funnels';
import { revenueQueryTypes } from '../../../constants/revenue';

const isCompose = (unit) =>
  unit.compose.revenue.queryType === revenueQueryTypes.ARPU ||
  unit.compose.revenue.queryType === revenueQueryTypes.PAYERS;

const executeRevenueQueries = (unit, executeId) =>
  isCompose(unit)
    ? executeDashboardComposeRevenue(unit, executeId)
    : executeDashboardRevenue(unit, executeId);

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch, { dashboard = {} }) => ({
  onExecuteQuery: () => {
    dashboard.units.forEach((unit) => {
      const executeId = v4();

      switch (unit.type) {
        case unitsTypes.EVENTS_TYPE:
          dispatch(executeDashboardEventQueries(unit, executeId));
          break;
        case unitsTypes.REVENUE_TYPE:
          dispatch(executeRevenueQueries(unit, executeId));
          break;
        case unitsTypes.USERS_TYPE:
          dispatch(executeDashboardUsers(unit, executeId));
          break;
        case unitsTypes.RETENTION_TYPE:
          dispatch(executeDashboardRetentionSimple(unit, executeId));
          break;
        case unitsTypes.RETENTION_COMPLEX_TYPE:
          dispatch(executeDashboardRetentionComplex(unit, executeId));
          break;
        case unitsTypes.FUNNELS_TYPE:
          dispatch(executeDashboardFunnel(unit, executeId));
          break;
        default:
          break;
      }
      dispatch(executeDashboardUnitQueriesStart(unit, executeId));
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ButtonExecuteDashboard);
